import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the FloorPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'floor',
})
export class FloorPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(input) {
    if (isNaN(input)) {
      input = input.substring(0,input.indexOf('.'));
      return input;
    } else {
      return Math.floor(input);
    }
  };
}



// WEBPACK FOOTER //
// ./src/shared/pipes/floor/floor.ts